import { configureStore } from '@reduxjs/toolkit';
import sendReducer from './slices/sendSice';

export const store = configureStore({
	reducer: {
		sendMessage: sendReducer
	},
});
